import React from "react";
import styled from "styled-components";
import {isMobile} from 'react-device-detect';
import { Link } from "react-router-dom";

import Container from "./container"
import Buttons from "./buttons"

const Show = styled.section`
    display: flex;
    flex-wrap: ${isMobile ? "wrap":"unset"};
    flex-flow: ${isMobile ? "column-reverse":"unset"};

    > div {
        flex-basis: ${isMobile ? 100:50}%;
    }
`
const Poster = styled.div`
    img {
        width: 100%; 
        border-radius: 3px;
    }
`
const Info = styled.div`
    padding: ${isMobile ? "0px":"15px 15px 15px 0px"};

    h3 {
        margin-top: ${isMobile ? 15:0}px;
        text-align: center;
        text-transform: uppercase;
        font-size: 180%;
        font-weight: bold;

        a {
            text-decoration: none;
            color: white;

            &:hover {
                text-decoration: underline;
            }
        }
        small {
            display: block;
            font-size: 70%;
        }
    }

    .banner {
        padding: 20px;
        text-align: center;
        font-size: 25px;
        border-top: 5px solid white;
        border-bottom: 5px solid white;
    }
    .location {
        margin-top: 10px;
    }
    .content {
        line-height: 1.5em;
    }
`

function ShowSimple({show}) {
  return (
    <Container>
        <Show>
            <Info>
                <h3>
                    <Link to={show.url}>
                        {show.title}
                    </Link>
                    {show.subtitle && <small>{show.subtitle}</small>}
                </h3>
                <div className="banner" style={{backgroundColor: show.bannerColor || "inherit"}}>
                    <div className="date">
                        {show.dateFormatted}
                        {' '}@{' '}
                        {show.timeFormatted}
                    </div>
                    <div className="location">{show.location}</div>
                </div>

                {show.description && <div className="content"><p>{show.description}</p></div>}
                {show.content && <div className="content" dangerouslySetInnerHTML={{__html: show.content}}></div>}

                {show.website && <p><a href={show.website} target="_blank">{show.website}</a></p>}

                <Buttons show={show} more tickets />
            </Info>
            <Poster>
                <Link to={show.url}>
                    <img src={show.poster} alt={show.title + " Poster"} />
                </Link>
            </Poster>            
        </Show>
    </Container>    
  );
}

export default ShowSimple;